function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.941 25.754L0 13.812l5.695-5.695 6.246 6.246L26.305 0 32 5.695z"
});

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 26,
    viewBox: "0 0 32 26"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDMyIDI2Ij4KICA8cG9seWdvbiBwb2ludHM9IjExLjk0MSAyNS43NTQgMCAxMy44MTIgNS42OTUgOC4xMTcgMTEuOTQxIDE0LjM2MyAyNi4zMDUgMCAzMiA1LjY5NSIvPgo8L3N2Zz4K";
export { SvgCheck as ReactComponent };